import { useWsEditor, WsEditor } from 'wisestep-base';

interface IComponentProps {
  rtrDescription: string;
  onRtrUpdate: (str: string | null) => void;
}

const RtrEditor = ({ rtrDescription, onRtrUpdate }: IComponentProps) => {
  const editor = useWsEditor(rtrDescription, onRtrUpdate);

  return <WsEditor editor={editor} resizable={true} editorHeight={640}></WsEditor>;
};

export default RtrEditor;
